import "../App.css";
export const PaddingWrapper = ({ children }) => {
  return <div className="paddingWrapper">{children}</div>;
};
